<div class="panel-body">
    <ng-content></ng-content>
</div>